import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { ExternalLink } from 'lucide-react';

const isPdfUrl = (url = '', filename = '') => /\.pdf($|\?)/i.test(url) || /\.pdf$/i.test(filename);

/**
 * DocumentLightbox
 * Popup om een afbeelding of PDF te bekijken.
 * Props:
 * - open / onOpenChange
 * - document: { url, filename } (url = publieke URL of blob URL)
 */
const DocumentLightbox = ({ open, onOpenChange, document: doc }) => {
  if (!doc) return null;
  const pdf = isPdfUrl(doc.url, doc.filename);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[92vh] overflow-hidden flex flex-col z-[300]" data-testid="document-lightbox">
        <DialogHeader className="flex-shrink-0">
          <div className="flex items-center justify-between gap-4 pr-8">
            <DialogTitle className="truncate text-base">{doc.filename || 'Document'}</DialogTitle>
            <Button variant="outline" size="sm" onClick={() => window.open(doc.url, '_blank')} data-testid="lightbox-open-tab">
              <ExternalLink className="w-4 h-4 mr-1" />
              Nieuw tabblad
            </Button>
          </div>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-auto flex items-center justify-center bg-muted/30 rounded-lg">
          {pdf ? (
            <iframe
              src={doc.url}
              title={doc.filename || 'PDF'}
              className="w-full h-[75vh] rounded-lg border-0"
              data-testid="lightbox-pdf"
            />
          ) : (
            <img
              src={doc.url}
              alt={doc.filename || 'Afbeelding'}
              className="max-w-full max-h-[75vh] object-contain rounded-lg"
              data-testid="lightbox-image"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentLightbox;
